//This is a login page

import React from "react";
import logo from "../../../assets/logo.png";
import styles from "./index.module.scss";
import { Button, Checkbox, Form, Input } from "antd";
import { useAuthActions, useAuthDatas } from "../../../auth/JWTAuthProvider";
import translate from "../../../i18n/translate";
export default function Login() {
  const { signInUser } = useAuthActions();
  const { isLoading } = useAuthDatas();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src={logo} alt="" />

        <Form
          onFinish={signInUser}
          initialValues={
            process.env.REACT_APP_NODE_ENV === "development"
              ? {
                  rememberMe: true,
                  username: "root",
                  password: "root",
                }
              : {
                  rememberMe: true,
                    username: "",
                    password: "",
                }
          }
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: translate("form.error.username_required"),
              },
            ]}
          >
            <Input placeholder={"Пользователь"} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.reject(
                      new Error(translate("form.error.password_required"))
                    );
                  }
                  return Promise.resolve();

                  // return Promise.reject(
                  //   new Error("Password length must be at least 8 characters")
                  // );
                },
              }),
            ]}
          >
            <Input.Password placeholder={"Пароль"} />
          </Form.Item>
          <Form.Item name="rememberMe" valuePropName="checked">
            <Checkbox>{translate("misc.remember_me")}</Checkbox>
          </Form.Item>
          <Form.Item>
            <Button style={{ width: "100%" }} htmlType="submit" type="primary" loading={isLoading}>
              {translate("button.login")}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}
